import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Preloader } from "@/components/Preloader";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Services } from "@/components/Services";
import { ScrollScene } from "@/components/ScrollScene";
import { Process } from "@/components/Process";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export const Home = () => {
    const [ready, setReady] = useState(false);

    return (
        <>
            <AnimatePresence mode="wait">
                {!ready && (
                    <Preloader key="preloader" onComplete={() => setReady(true)} />
                )}
            </AnimatePresence>
            <Navbar />
            <main>
                <Hero ready={ready} />
                <EditorialMarquee />
                <Services />
                <ScrollScene />
                <Process />
                <About />
                <Contact />
            </main>
            <Footer />
        </>
    );
};
